function VideoSection() {
  const teamVideo = "https://assets.bluestar-rowing.com/assets/team_video.mp4";

  return (
    <div className="section-seamless video-section" style={{
      width: '100vw',
      position: 'relative',
      backgroundColor: '#111827',
      display: 'block'
    }}>
      <video
        style={{
          width: '100%',
          height: 'auto',
          display: 'block'
        }}
        controls
        poster=""
      >
        <source
          src={teamVideo}
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}

export default VideoSection;